/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Content from 'app/components/common/Content.jsx';
import PostModal from 'app/components/PostModal/PostModalV2.jsx';

class ActionChooser extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        };

        this.showPostModal = this.showPostModal.bind(this);

    }

    showPostModal(e) {

		e.preventDefault();

		let postModal = (
			<PostModal
				{...this.props} />
		);

		this.props.addModal(postModal);

	}

    render() {
        return (
            <Content contentClass="inline-modal" {...this.props}>
                <div className="onboarding-wrapper">
                    <h2>Let's Start Posting</h2>
                    <p className="top-copy">Try one of our popular posting options.</p>
                    <div className="action-wrapper">
                        <div className="action-button" onClick={() => {
                            let onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;

                            if (onboarding) {
                                mixpanel.track("Social Onboarding - Choose Post Method", {
                                    method: 'create route'
                                });
                                if (this.props.recordEvent) {
                                    this.props.recordEvent({
                                        pub_id: this.props.user.detail.id,
                                        event_name: 'Social Onboarding - Choose Post Method',
                                        event_data: {
                                            method: 'create route'
                                        }
                                    })
                                }
                            }
                            this.props.router.navigate("/content/feed")
                        }}>
                            <div className="action-icon feed">
                                <i className="icon ion-social-rss"></i>
                            </div>
                            <div className="action-label">
                                Set Up Auto Posting
                            </div>
                        </div>
                        <div className="action-button" onClick={(e) => {
                            let onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;

                            if (onboarding) {
                                mixpanel.track("Social Onboarding - Choose Post Method", {
                                    method: 'manual post'
                                });
                                if (this.props.recordEvent) {
                                    this.props.recordEvent({
                                        pub_id: this.props.user.detail.id,
                                        event_name: 'Social Onboarding - Choose Post Method',
                                        event_data: {
                                            method: 'manual post'
                                        }
                                    })
                                }
                            }
                            this.showPostModal(e);
                        }}>
                            <div className="action-icon new-post">
                                <i className="icon ion-edit"></i>
                            </div>
                            <div className="action-label">
                                Create a Post
                            </div>
                        </div>
                    </div>
                </div>
            </Content>
        );
    }
}

ActionChooser.displayName = "ActionChooser";

export default ActionChooser;
